import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { activityLogsKeys } from './getActivityLogs';
import { fileDetailsKeys } from './getFileDetails';

import { isResponseError } from '../../../../api/config';
import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { UpdateFileEntryResponse } from '../../../../types';

const url = `${PREFIX_URL}/inbox-documents/:fileId`;

export type MarkReadDTO = {
  fileId: number;
  read: boolean;
};

export const markRead = ({ fileId, read }: MarkReadDTO): Promise<UpdateFileEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { fileId }),
    { read },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type useMarkReadOptions = {
  fileId: number;
  projectId?: string;
  config?: MutationConfig<typeof markRead>;
};

export const useMarkRead = ({ fileId, projectId, config }: useMarkReadOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (isResponseError(data)) {
        return;
      }

      queryClient.setQueryData([...fileDetailsKeys.detail({ fileId })], (prev: any) => {
        return {
          ...prev,
          data: data.data['inbox-document'],
        };
      });

      queryClient.invalidateQueries([...activityLogsKeys.list(fileId)]);
    },
    ...config,
    mutationFn: ({ read }) => markRead({ fileId, read }),
  });
};
